import { render } from "./PagamentoBoletoSucesso.vue?vue&type=template&id=3f87bcd6"
import script from "./PagamentoBoletoSucesso.vue?vue&type=script&lang=js"
export * from "./PagamentoBoletoSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__